import React, { useState } from 'react';
import { Modal, ModalBody } from 'reactstrap';
import PrivateJobDocuments from './PrivateJobDocuments';

/**
 * The pop-up asking the importer for the Bill of Lading and TIN once a bid has
 * been accepted.
 *
 * The inline panel on the job screens collects the same things, but an importer
 * who goes straight to their milestones meets only the "documents missing"
 * banner. This opens over the page with the fields in it, so the request is the
 * first thing they see.
 *
 * Shown only to the importer who owns the job, only once a bid is accepted, and
 * only while something is outstanding. Closing it is allowed — paying and
 * supplying documents are deliberately independent — and it returns the next
 * time they open the job. Once they submit, the refreshed job reports complete
 * and it unmounts.
 *
 * @param {object}   docs       privateJobDocs from the API
 * @param {string}   jobId      job uuid
 * @param {boolean}  isOwner    the viewer posted this job
 * @param {boolean}  isAwarded  a clearing agent has been selected
 * @param {function} refresh    re-fetch the job after a successful submit
 */
const PostAwardDocumentsModal = ({ docs, jobId, isOwner, isAwarded, refresh }) => {
  const [dismissed, setDismissed] = useState(false);

  const outstanding = isOwner && isAwarded && docs && docs.post_award_docs_complete === false;
  if (!outstanding) return null;

  const close = () => setDismissed(true);

  // Under Telex Release there is no document, so only the TIN is asked for.
  const needsLading = !docs.is_telex && !docs.has_lading;

  return (
    <Modal isOpen={!dismissed} toggle={close} className="modal-lg post-award-docs-modal">
      <div className="modal-header">
        <h5 className="modal-title mb-0">Documents needed to start clearing</h5>
        <button type="button" className="close" onClick={close} aria-label="Close">
          &times;
        </button>
      </div>
      <ModalBody>
        <p className="mb-0">
          A clearing agent has been selected for this job. Please provide
          {needsLading ? ' the original Bill of Lading and ' : ' '}
          your Tax Identification Number so they can begin.
        </p>
        <PrivateJobDocuments docs={docs} jobId={jobId} editable refresh={refresh} idSuffix="modal" />
      </ModalBody>
    </Modal>
  );
};

export default PostAwardDocumentsModal;
